/**
 * Shared state for the DQ Workbench tabs (Overview / FP Grid / Trending /
 * Reports). Market lives in the URL (`?market=`) so it survives reload and
 * deep-links; the refresh counter is layout-local and bumps to force the
 * active tab's `useDataFetching` to refetch.
 */
import React, { createContext, useContext } from 'react'

export interface DataExceptionsCtx {
  /** '' (all), 'ANZ' or 'USA' - the platform-wide market vocab. */
  market: string
  setMarket: (value: string) => void
  /** Bumped by the header Refresh button; tabs key their fetch on it. */
  refreshKey: number
  refresh: () => void
}

const Ctx = createContext<DataExceptionsCtx | null>(null)

export const DataExceptionsProvider = Ctx.Provider

export const useDataExceptionsCtx = (): DataExceptionsCtx => {
  const ctx = useContext(Ctx)
  if (!ctx) {
    throw new Error('useDataExceptionsCtx must be used within DataExceptionsLayout')
  }
  return ctx
}
